import AddCircle from "@mui/icons-material/AddCircle";
import RemoveCircle from "@mui/icons-material/RemoveCircle";
import { Box, Grid, Grid2, IconButton, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGuestCount, updateTotalCount } from "../../store/slice/Ticketing.slice";
import { useTheme } from "@emotion/react";

const GuestCount = ({item,handleSelect}) => {
  const[currentGuestCounts,setCurrentGuests]=useState(
    {
      adult: 1,
      child: 0,
      kid: 0,
      baby: 0,
      toddler: 0,
    }
  )
  const dispatch = useDispatch();
  const theme =useTheme()
  const { widgetConfig } = useSelector((store) => store?.widgetSettings);
  const { totalCount,guestCounts , adult, child, kid, baby, toddler,reservType,SelectedEventOrStdResType,EventOrStdTicketTypesData,languageWords } = useSelector(
    (store) => store.Ticketing
  );

  // const currentGuestCounts = guestCounts[item.idreservationtype] || {
  //   adult: 1,
  //   child: 0,
  //   kid: 0,
  //   baby: 0,
  //   toddler: 0,
  // };
  useEffect(()=>{
    if(guestCounts[item.idreservationtype])
    setCurrentGuests(guestCounts[item.idreservationtype])
  },[guestCounts])

  const guestTypes = [
    { key: "field1Text", type: "adult", count:guestCounts[item.idreservationtype]?.adult ||  currentGuestCounts?.adult },
    { key: "field2Text", type: "child", count:guestCounts[item.idreservationtype]?.child ||  currentGuestCounts?.child },
    { key: "field3Text", type: "kid", count:guestCounts[item.idreservationtype]?.kid ||  currentGuestCounts?.kid },
    { key: "field4Text", type: "baby", count:guestCounts[item.idreservationtype]?.baby || currentGuestCounts?.baby },
    { key: "field5Text", type: "toddler", count:guestCounts[item.idreservationtype]?.toddler || currentGuestCounts?.toddler },
  ];

  useEffect(() => {
    dispatch(updateTotalCount());
  }, [currentGuestCounts, dispatch]);
 

  // Function to handle increment/decrement
  const handleChange = (guestType, increment) => {
    if(increment){
        if(totalCount >= (SelectedEventOrStdResType?.maximumTickets- SelectedEventOrStdResType?.soldTickets) || (EventOrStdTicketTypesData?.showMaxTicketsPerSale && totalCount >= EventOrStdTicketTypesData?.maxTicketsPerSale )){
            return
        }
    }
    handleSelect(item)
    dispatch(
      setGuestCount({
        idreservationtype: item.idreservationtype,
        guestType,
        count: increment
          ? currentGuestCounts[guestType] + 1
          : Math.max(currentGuestCounts[guestType] - 1, 1),
      })
    );
  };

  return (

<Grid container spacing={2} justifyContent="flex-start" >
  {guestTypes.map(({ key, type, count }) =>
    widgetConfig?.fields?.[key] && reservType?.isStandardTicket ? (
      <Grid item xs={12} sm={12} md={6} key={key}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: "0.8rem",
            mb: 1.5,
            p: 1.5,
            backgroundColor: "#FFFFFF",
            borderRadius: "6px",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.08)",
            border: "1px solid #e0e0e0",
            "&:hover": {
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            },
            minWidth: "100%",
            flexWrap: "wrap",
          }}
        >
          <Typography
            sx={{ flex: 1, fontWeight: 500, color: "#333", fontSize: "0.875rem" }}
          >
            {widgetConfig.fields[key]}
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: "0.8rem" }}>
            <IconButton
              onClick={() => handleChange(type, false)}
              disabled={count === 0}
              sx={{
                color: count === 0 ? "#B0BEC5" : "#FF3D00",
                "&:hover": {
                  color: count === 0 ? "#B0BEC5" : "#E57373",
                },
              }}
            >
              <RemoveCircle sx={{ fontSize: "1.25rem" }} />
            </IconButton>
            <TextField
              value={count}
              variant="outlined"
              size="small"
              sx={{
                width: "50px",
                textAlign: "center",
                backgroundColor: "#fafafa",
                border: "1px solid #e0e0e0",
                borderRadius: "6px",
                color: "#333",
                fontWeight: 600,
                fontSize: "0.875rem",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#e0e0e0" },
                  "&:hover fieldset": { borderColor: "#FF3D00" },
                  "&.Mui-disabled": { backgroundColor: "#f0f0f0" },
                },
              }}
              disabled
            />
            <IconButton
              onClick={() => handleChange(type, true)}
              sx={{
                color: "#00C853",
                "&:hover": { color: "#81C784" },
              }}
            >
              <AddCircle sx={{ fontSize: "1.25rem" }} />
            </IconButton>
          </Box>
        </Box>
      </Grid>
    ) : key === "field1Text" ? (
      <Grid item xs={12} sm={12} md={6} key={key}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: "0.8rem",
            mb: 1.5,
            p: 1.5,
            backgroundColor: "#FFFFFF",
            borderRadius: "6px",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.08)",
            border: "1px solid #e0e0e0",
            "&:hover": {
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            },
            minWidth: "100%",
            flexWrap: "wrap",
          }}
        >
          <Typography
            sx={{ flex: 1, fontWeight: 500, color: "#333", fontSize: "0.875rem" }}
          >
            {widgetConfig.fields[key]}
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: "0.8rem" }}>
            <IconButton
              onClick={() => handleChange(type, false)}
              disabled={count === 0}
              sx={{
                color: count === 0 ? "#B0BEC5" : "#FF3D00",
                "&:hover": {
                  color: count === 0 ? "#B0BEC5" : "#E57373",
                },
              }}
            >
              <RemoveCircle sx={{ fontSize: "1.25rem" }} />
            </IconButton>
            <TextField
              value={count}
              variant="outlined"
              size="small"
              sx={{
                width: "50px",
                textAlign: "center",
                backgroundColor: "#fafafa",
                border: "1px solid #e0e0e0",
                borderRadius: "6px",
                color: "#333",
                fontWeight: 600,
                fontSize: "0.875rem",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#e0e0e0" },
                  "&:hover fieldset": { borderColor: "#FF3D00" },
                  "&.Mui-disabled": { backgroundColor: "#f0f0f0" },
                },
              }}
              disabled
            />
            <IconButton
              onClick={() => handleChange(type, true)}
              sx={{
                color: "#00C853",
                "&:hover": { color: "#81C784" },
              }}
            >
              <AddCircle sx={{ fontSize: "1.25rem" }} />
            </IconButton>
          </Box>
        </Box>
      </Grid>
    ) : null
  )}
</Grid>





  );
};

export default GuestCount;
